import React, { useMemo } from 'react';
import { ImageViewer, PdfViewer } from '@europrocurement/flexy-components';
import { useDocumentPreviewContext } from '../../../providers';
import NoResult from '../NoResult/NoResult';

type DocumentViewerProps = {
    isResponsive?: boolean;
    verticalScroll?: boolean;
};
const DocumentViewer: React.FunctionComponent<DocumentViewerProps> = function ({
    isResponsive = false,
    verticalScroll = false,
}) {
    const { previewLoading, documentPreview } = useDocumentPreviewContext();

    const viewer = useMemo(() => {
        if (!documentPreview) {
            return null;
        }

        const { fileName, fileType, content } = documentPreview;
        const blob = new Blob([content as unknown as string], {
            type: fileType === 'pdf' ? 'application/pdf' : 'application/octet-stream',
        });
        const fileURL = URL.createObjectURL(blob);

        if (fileType && fileType === 'pdf') {
            return (
                <PdfViewer
                    title={fileName}
                    pdfUrl={fileURL}
                    showTitle={false}
                    defaultPage={1}
                    isResponsive={isResponsive}
                    verticalScroll={verticalScroll}
                />
            );
        }

        if (fileType && ['jpg', 'jpeg', 'png'].includes(fileType)) {
            return <ImageViewer url={fileURL} />;
        }

        return <NoResult title="Document non pris en charge" />;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentPreview?.fileName, documentPreview?.fileType, documentPreview?.content]);

    if (previewLoading) {
        return <NoResult title="Chargement en cours" />;
    }

    if (!viewer) {
        return <NoResult title="Aucun document sélectionné" />;
    }

    return viewer;
};

export default DocumentViewer;
